import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledEmptyListWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16rem;
`;
